export class CollectPayReq {

    locId : number;
    amount : number;
    payerVa: string;
    paymentType: string;
}
